import { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';

/** Traductions site public créateur (`lo-public-site/*.json` via `translations[lang].loPublicSite`). */
export function useLoPublicSiteTranslation() {
  const { t: baseT, language, changeLanguage } = useTranslation();

  const t = useCallback(
    (key: string, params?: Record<string, string>): string => {
      const value = baseT(`loPublicSite.${key}`, params);
      return typeof value === 'string' ? value : key;
    },
    [baseT],
  );

  return { t, language, changeLanguage };
}
